// Shared fetch helper — throws { status, ...body } on non-OK responses.
async function apiFetch(url, options = {}) {
  const response = await fetch(url, {credentials: "include", ...options });
  if (response.status === 401) {
    const err = new Error("Session expired");
    err.status = 401;
    throw err;
  }

  if (!response.ok) {
    throw new Error("Failed to fetch sheet Scores");
  }
  // if (!response.ok) {
  //   const body = await response.json().catch(() => ({}));
  //   throw { status: response.status, ...body };
  // }
  return response.json();
}


// Reads all score rows from the Scores sheet endpoint.
// API_BASE should be the backend base URL (for example from config.js).
// Throws { status: 401 } when the user session has expired.
// Throws an Error for other non-OK responses.
export async function readScoresData(API_BASE) {
  return apiFetch(`${API_BASE}/api/read`);
  // const response = await fetch(`${API_BASE}/api/read`, {
  //   credentials: "include",
  // });

  // if (response.status === 401) {
  //   throw { status: 401, message: "Session expired" };
  // }

  // if (!response.ok) {
  //   throw new Error("Failed to fetch sheet Scores");
  // }

  // return await response.json();
}

export async function  readUserInfo(API_BASE) {
  return apiFetch(`${API_BASE}/api/user`);
}

export async function readResponses(API_BASE, tab = "Responses") {
  // return apiFetch(`${API_BASE}/api/responses`);
  return apiFetch(`${API_BASE}/api/read-responses?tab=${encodeURIComponent(tab)}`);
} 

export async function isEntryLocked(API_BASE, entryNumber) {
  return apiFetch(`${API_BASE}/api/is-locked?entryNumber=${encodeURIComponent(entryNumber)}`);
}

// Writes a single row to a target sheet via the backend write endpoint.
// row: array of values to append/update
// sheet: destination tab name in the spreadsheet
// API_BASE: backend base URL
// Re-throws backend errors so callers can handle locked/session states.
export async function writeSheetData({ row, sheet, API_BASE }) {
  const url = `${API_BASE}/api/write`;
  try {
    const response = await fetch(url, {
      method: "POST",
      body: JSON.stringify({ row, sheet }),
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    });
    const data = await response.json();
    if (!response.ok) {
      const err = new Error(data?.error || `Request failed (${response.status})`);
      Object.assign(err, { status: response.status }, data);
      throw err;
    }
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

// Posts a special-award action (nominate | submit | recall | remove) to the backend.
// email: the judge's identifier
// action: one of the strings above
// entryNum: the entry being acted on
// row (optional): full row array for nominate/submit/recall
export async function specialAwardsAction(API_BASE, { email, action, entryNum, row }) {
  return apiFetch(`${API_BASE}/api/special-awards`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, action, entryNum, ...(row ? { row } : {}) }),
  });
}


